<script lang="ts">
	import AssetImage from '#lib/AssetImage.svelte';
	import FileChip from '#lib/FileChip.svelte';
	import type { AssetRef } from '#src/types/chat.ts';
	import IconError from '~icons/material-symbols/error-outline-rounded';

	interface Props {
		assets?: AssetRef[];
		onimageclick?: (asset: AssetRef) => void;
	}

	const { assets, onimageclick }: Props = $props();

	// Both directions render the same way: an agent-generated image and a
	// visitor-uploaded one are both just an image belonging to this message.
	const renderableAssets = $derived(assets ?? []);
</script>

{#if renderableAssets.length}
	<div class="assets">
		{#each renderableAssets as asset (asset.call_id ?? asset.assetId)}
			{#if asset.error}
				<div class="asset-error" title={asset.error || 'Generation failed'}>
					<IconError />
				</div>
			{:else if asset.kind === 'image'}
				<AssetImage {asset} onclick={onimageclick && (() => onimageclick(asset))} />
			{:else}
				<FileChip name={asset.name ?? ''} pageCount={asset.pageCount} href={asset.url} />
			{/if}
		{/each}
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.assets {
		@include lib.flex-row();
		// flex-start so images of differing ratios keep their own height instead
		// of being stretched to the tallest one in the row.
		@include lib.flex-align(flex-start, flex-start);
		flex-wrap: wrap;
		gap: 0.5rem;

		.asset-error {
			@include lib.flex-row();
			@include lib.flex-align(center, center);
			height: 12rem;
			width: 12rem;
			border-radius: 0.5rem;
			background: var(--surface-error-subtle);
			color: var(--text-error);
			font-size: 3rem;
			flex-shrink: 0;
		}
	}
</style>
